import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { TokenService } from "../tokenManagement/token.service";
import { Config } from "../config";
import { environment } from "../../../environments/environment";
import { HttpheaderService } from "../helpers/httpheader.service";
import { Httpheaders } from "../model/requests/httpheaders";

@Injectable()
export class CustomHttpInterptors implements HttpInterceptor {
  url = this.coreservices.url;
  _body = this.coreservices.body;
  username = environment.appUser;
  password = environment.appPwd;

  public ctrlToken: string;
  public inVa11: string;
  public inVal2: string;
  doctoken: string;
  //    public
  public interceptorHeader = new Httpheaders();
  constructor(
    private tokenService: TokenService,
    private httpHeaderService: HttpheaderService,
    private coreservices: Config
  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let specialurl = req.url.substring(req.url.indexOf(".com")); //we have to format the url for encoding **get from .com
    specialurl = specialurl.substring(4); //trim away the .com
    specialurl = this.countryUrlHelper(specialurl);
    //check if the the App is registered.
    let isAccessControl = this.tokenService.getAccessToken();
    if (
      !isAccessControl ||
      req.url.includes("getToken") ||
      req.url.includes("extreme-ip-lookup.com")
    ) {
      req = req.clone({
        setHeaders: {
          // Authorization: "Basic " + btoa(this.username + ":" + this.password),
          "Content-Type": "application/json",
        },
      });
      return next.handle(req);
    }
    //for duc upload.. This is currently not in use, kindly req. for actual url from the BE guys and insert into the ENV for the business document service.this is for test purpose, I repeat, test purpose
    if (
      req.url ===
        "https://sandbox.globalaccelerex.com/api/accelerex-integrator/v1/admin/create/upload" ||
      req.url.includes("analysis_service")
    ) {
      let url = req.urlWithParams.substring(req.urlWithParams.indexOf(".com"));
      url = url.substring(4);
      url = this.countryUrlHelper(url);
      this.setHttpHeader(req.method, url);
      req = req.clone({
        setHeaders: {
          Nonce: this.interceptorHeader.Nonce,
          Timestamp: this.interceptorHeader.Timestamp,
          X_TOKEN: this.interceptorHeader.X_TOKEN,
          Signature: this.interceptorHeader.signature.toString(),
          X_CLIENT_ID: this.interceptorHeader.X_CLIENT_ID,
          "X-AUTH-TOKEN": this.interceptorHeader.X_AUTH_TOKEN,
          "Content-Type": "application/json",
        },
      });
      return next.handle(req);
    }
    if (req.url.includes("rexpaysupport")) {
      let url = req.url.split(".com")[1];
      const detail = this.tokenService.getPersonalDetails();
      const email = detail["clientEmail"];
      this.setHttpHeader(req.method, url);
      req = req.clone({
        setHeaders: {
          Accept: "*/*",
          // "Content-Type": "multipart/form-data",
          email,
          Nonce: this.interceptorHeader.Nonce,
          X_TOKEN: this.interceptorHeader.X_TOKEN,
          "X-AUTH-TOKEN": this.interceptorHeader.X_AUTH_TOKEN,
          Signature: this.interceptorHeader.signature.toString(),
          Timestamp: this.interceptorHeader.Timestamp,
        },
      });
      return next.handle(req);
    }
    // if a login request, make request with specific headers..or a forgot password request
    if (
      req.url == this.coreservices.url + this.coreservices.login ||
      req.url == this.coreservices.url + this.coreservices.loginv2 ||
      req.url.includes("forgotPassword") ||
      req.url.includes("activate") ||
      req.url.includes("recoverPassword") ||
      req.url.includes("token") ||
      specialurl == "/api/pgs/admin/v1/updateUsers" ||
      specialurl == "/api/pgs/admin/v1/create" ||
      specialurl == "/api/pgs/admin/v1/clientUserRoles" ||
      specialurl == "/api/pgs/v1/login"
    ) {
      let url = req.url.substring(req.url.indexOf(".com")); //we have to format the url for encoding **get from .com

      url = url.substring(4); //trim away the .com
      url = this.countryUrlHelper(url);
      this.setLoginHeader(req.method, url);
      req = req.clone({
        setHeaders: {
          Nonce: this.interceptorHeader.Nonce,
          Timestamp: this.interceptorHeader.Timestamp,
          X_TOKEN: this.interceptorHeader.X_TOKEN,
          Signature: this.interceptorHeader.signature.toString(),
          "Content-Type": "application/json",
        },
      });
      return next.handle(req);
    }

    // for other requests
    else {
      let url = req.urlWithParams.substring(req.urlWithParams.indexOf(".com"));
      url = url.substring(4);
      url = this.countryUrlHelper(url);
      this.setHttpHeader(req.method, url);
      req = req.clone({
        setHeaders: {
          Nonce: this.interceptorHeader.Nonce,
          Timestamp: this.interceptorHeader.Timestamp,
          X_TOKEN: this.interceptorHeader.X_TOKEN,
          Signature: this.interceptorHeader.signature.toString(),
          X_CLIENT_ID: this.interceptorHeader.X_CLIENT_ID,
          "X-AUTH-TOKEN": this.interceptorHeader.X_AUTH_TOKEN,
          "Content-Type": "application/json",
        },
      });
      return next.handle(req);
    }
  }

  //set Generic Headers
  setHttpHeader(method: string, url: string) {
    this.httpHeaderService.setSignature(method, url);
    this.interceptorHeader.accessKey =
      this.httpHeaderService.httpheader.accessKey;
    this.interceptorHeader.accessToken =
      this.httpHeaderService.httpheader.accessToken;
    this.interceptorHeader.Nonce = this.httpHeaderService.httpheader.Nonce;
    this.interceptorHeader.Timestamp =
      this.httpHeaderService.httpheader.Timestamp;
    this.interceptorHeader.X_TOKEN = this.httpHeaderService.httpheader.X_TOKEN;
    this.interceptorHeader.X_USER_TOKEN =
      this.httpHeaderService.httpheader.X_USER_TOKEN;
    this.interceptorHeader.signature =
      this.httpHeaderService.httpheader.signature;
    this.interceptorHeader.X_CLIENT_ID =
      this.httpHeaderService.httpheader.X_CLIENT_ID;
    this.interceptorHeader.X_AUTH_TOKEN =
      this.httpHeaderService.httpheader.X_AUTH_TOKEN;
  }

  //login header
  setLoginHeader(method: string, url: string) {
    this.httpHeaderService.setLoginHeader(method, url);
    this.interceptorHeader.X_TOKEN =
      this.httpHeaderService.httpheader.accessToken;
    this.interceptorHeader.signature =
      this.httpHeaderService.httpheader.signature;
    this.interceptorHeader.Timestamp =
      this.httpHeaderService.httpheader.Timestamp;
    this.interceptorHeader.Nonce = this.httpHeaderService.httpheader.Nonce;
    this.interceptorHeader.X_CLIENT_ID =
      this.httpHeaderService.httpheader.X_CLIENT_ID;
  }

  setDocHeader() {
    this.httpHeaderService.getTokens();
    this.doctoken = this.httpHeaderService.httpheader.accessToken;
  }

  countryUrlHelper(url) {
    if (url.includes(".gh")) {
      return url.substring(3);
    }
    return url;
  }
}
